import { render, staticRenderFns } from "./vuex-form-provider.vue?vue&type=template&id=a89c229c&scoped=true&"
import script from "./vuex-form-provider.ts?vue&type=script&lang=ts&"
export * from "./vuex-form-provider.ts?vue&type=script&lang=ts&"
import style0 from "./vuex-form-provider.scss?vue&type=style&index=0&id=a89c229c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89c229c",
  null
  
)

export default component.exports